import { commentsInitState } from '@/utils'
import { httpAuthRequest } from '@/services'

const state = commentsInitState()

const actions = {
    async getComments({ commit }) {
        const response = await httpAuthRequest('get', '/comments/')
        if (response.success) commit('SET_COMMENTS', response.data.results)
    },

    async addComment({ commit }, payload) {
        const response = await httpAuthRequest('post', '/comments/', payload)
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Comment has been added successfully' })
            commit('ADD_COMMENT', response.data)
        } else commit('SET_ALERT', { type: 'error', message: 'Something went wrong' })

        return response.success
    },

}

const mutations = {
    ADD_COMMENT(state, comment) {
        state.comments = [...state.comments, comment]
    },

    SET_COMMENTS(state, comments) {
        state.comments = comments
    },

    RESET_STATE(state) {
        Object.assign(state, commentsInitState())
    }
}

export default {
    state,
    actions,
    mutations
}
